import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  addDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";

export default function OpenSaving() {
  const [members, setMembers] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [amount, setAmount] = useState("");

  // 🔹 Load members
  useEffect(() => {
    const loadMembers = async () => {
      const snap = await getDocs(collection(db, "members"));
      setMembers(snap.docs.map(d => d.data()));
    };
    loadMembers();
  }, []);

  // 🔹 Filter search
  const filtered = members.filter(m =>
    m.name?.toLowerCase().includes(search.toLowerCase()) ||
    m.mobile?.includes(search) ||
    m.memberId?.includes(search)
  );

  // 🔹 Check duplicate saving
  const checkSavingExists = async memberId => {
    const q = query(
      collection(db, "savings_accounts"),
      where("memberId", "==", memberId)
    );
    const snap = await getDocs(q);
    return !snap.empty;
  };

  // 🔹 Open Saving A/C
  const openSaving = async () => {
    if (!selected || !amount) {
      alert("Select member & amount");
      return;
    }

    const exists = await checkSavingExists(selected.memberId);
    if (exists) {
      alert("Saving account already exists for this member");
      return;
    }

    // Create saving account
    await addDoc(collection(db, "savings_accounts"), {
      memberId: selected.memberId,
      name: selected.name,
      mobile: selected.mobile,
      openingDate: new Date().toLocaleDateString(),
      openingAmount: Number(amount),
      status: "ACTIVE",
    });

    // Create first ledger entry
    await addDoc(collection(db, "saving_ledger"), {
      memberId: selected.memberId,
      date: new Date().toLocaleDateString(),
      credit: Number(amount),
      debit: 0,
      balance: Number(amount),
      remark: "Opening Balance",
    });

    alert("Saving Account Opened Successfully ✅");
    setSelected(null);
    setSearch("");
    setAmount("");
  };

  return (
    <div className="container-fluid">
      <h4>Open Saving Account</h4>

      {/* 🔍 Search */}
      <input
        className="form-control mb-2"
        placeholder="Search Name / Mobile / Member ID"
        value={search}
        onChange={e => setSearch(e.target.value)}
      />

      {/* 📋 Search Result */}
      {search && (
        <div className="list-group mb-3">
          {filtered.map(m => (
            <button
              key={m.memberId}
              className="list-group-item list-group-item-action"
              onClick={() => {
                setSelected(m);
                setSearch("");
              }}
            >
              {m.memberId} - {m.name}
            </button>
          ))}
        </div>
      )}

      {/* 🧾 Form */}
      {selected && (
        <div className="card p-3">
          <p><b>Member ID:</b> {selected.memberId}</p>
          <p><b>Name:</b> {selected.name}</p>
          <p><b>Mobile:</b> {selected.mobile}</p>

          <input
            type="number"
            className="form-control mb-2"
            placeholder="Opening Amount"
            value={amount}
            onChange={e => setAmount(e.target.value)}
          />

          <button className="btn btn-primary" onClick={openSaving}>
            Open Saving A/C
          </button>
        </div>
      )}
    </div>
  );
}